/**
 * Shared coach helpers used across chat surfaces (avatar, typing indicator, etc.).
 */

export const getCoachInitials = (promptInfo) => {
  if (!promptInfo || !promptInfo.name) {
    return 'JL'; // Default fallback
  }
  const name = promptInfo.name.trim();
  const lower = name.toLowerCase();
  if (lower.includes('marcus')) return 'CM';
  if (lower.includes('justin')) return 'CJ';
  if (lower.includes('eli')) return 'CE';
  if (lower.includes('default coach')) return 'DC';

  const words = name.split(' ');
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
  return 'JL';
};
